module.exports = __webpack_public_path__ + "static/media/selo-grill.6863e37d.png";